import { Routes, Route } from 'react-router-dom';
import PrivateRoute from '../components/common/PrivateRoute';
import FinanceiroLayout from '../components/Products/Financeiro/FinanceiroLayout.jsx';
import ContratosPage from '../components/Products/Financeiro/pages/ContratosPage.jsx';
import ReceitasPage from '../components/Products/Financeiro/pages/ReceitasPage.jsx';
import DespesasPage from '../components/Products/Financeiro/pages/DespesasPage.jsx';
import CadastroDespesasPage from '../components/Products/Financeiro/pages/CadastroDespesasPage.jsx';
// --- ADICIONADO ---
import DashboardPage from '../components/Products/Financeiro/pages/DashboardPage.jsx';
import MetasPage from '../components/Products/Financeiro/pages/MetasPage.jsx';

const FinanceiroRoutes = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PrivateRoute adminOnly>
            <FinanceiroLayout />
          </PrivateRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route path="dashboard" element={<DashboardPage />} />
        <Route path="contratos" element={<ContratosPage />} />
        <Route path="receitas" element={<ReceitasPage />} />
        <Route path="pagamentos" element={<ReceitasPage />} />
        <Route path="despesas" element={<DespesasPage />} />
        <Route path="despesas/cadastro" element={<CadastroDespesasPage />} />
        <Route path="metas" element={<MetasPage />} />
      </Route>
    </Routes>
  );
};

export default FinanceiroRoutes;